<template>
  <div>
    <span v-if="title">{{ title }}</span>
    <v-autocomplete
      :label="label"
      item-text="title"
      item-value="id"
      outlined
      :dense="dense"
      hide-no-data
      clearable
      auto-select-first
      :hide-selected="false"
      :items="placesFiltered"
      :search-input.sync="searchPlace"
      :error-messages="errors"
      :loading="$apollo.queries.places.loading || loading"
      :disabled="loading"
      v-model="placeId"
      @input="$emit('change', $event)"
    />
  </div>
</template>

<script>
import placesQuery from '@/services/gql/types/Places/queries/placesGrid.gql'
export default {
  name: 'PlacePicker',
  props: {
    value: {
      type: Number,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    editOnly: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchPlace: null,
      places: []
    }
  },
  computed: {
    placeId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    placesFiltered () {
      if (this.searchPlace === null) return this.places
      return this.places
        .filter(item => item.title.toLowerCase().indexOf(this.searchPlace.toLowerCase()) !== -1)
    },
    selectedPlace () {
      if (!this.value) return null
      return this.places.find(item => item.id === this.value)
    }
  },
  apollo: {
    places: {
      fetchPolicy: 'network-only',
      query: placesQuery,
      manual: true,
      result (res) {
        this.places = res.data.places.list
      }
    }
  }
}
</script>
